var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _path0, _g4, _path1, _path10, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScope3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13495_34396)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1169 33.6349H42.7749C41.9818 27.5057 38.9185 25.8428 35.2586 25.8428C33.6609 25.8428 32.1769 26.1604 30.9453 27.0267C33.5194 28.0457 35.231 30.2348 36.1169 33.6349Z",
    fill: "#08533F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13495_34396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 25,
    width: 13,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.668 25.6084H43.0019V33.874H30.668V25.6084Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13495_34396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.116 33.635V33.849H42.774C42.8361 33.849 42.8936 33.8232 42.9345 33.7762C42.9757 33.73 42.9939 33.6688 42.9862 33.608C42.7857 32.0594 42.4413 30.7857 41.9751 29.7442C41.2762 28.1821 40.2968 27.1424 39.1381 26.505C37.9804 25.8666 36.6538 25.6289 35.2578 25.6289C34.4447 25.6289 33.6563 25.7095 32.91 25.9029C32.164 26.096 31.4601 26.4026 30.8214 26.8518C30.7572 26.897 30.7227 26.9742 30.7319 27.052C30.7412 27.1301 30.7925 27.1972 30.8657 27.2258C32.1188 27.7224 33.1563 28.4985 33.9948 29.5698C34.8331 30.6412 35.4715 32.0105 35.909 33.6888C35.9336 33.7835 36.0185 33.849 36.116 33.849V33.635L36.3232 33.5812C35.8743 31.8595 35.2144 30.4342 34.3319 29.306C33.4496 28.1781 32.3442 27.3503 31.0235 26.8279L30.9444 27.0268L31.0677 27.2021C31.6603 26.7848 32.314 26.4994 33.0176 26.3171C33.7206 26.1351 34.473 26.0569 35.2578 26.0569C36.1566 26.0569 37.013 26.1593 37.8011 26.4029C38.9844 26.77 40.016 27.4484 40.8377 28.6003C41.659 29.7525 42.2673 31.3875 42.5618 33.6627L42.774 33.635V33.421H36.116V33.635Z",
    fill: "#CCF0E1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2588 15.21C34.0768 15.21 33.0011 15.6485 32.1746 16.3674C32.8511 17.3585 33.2471 18.5547 33.2471 19.8419C33.2471 21.1687 32.8237 22.395 32.1094 23.4027C32.9436 24.1567 34.046 24.6189 35.2588 24.6189C37.8563 24.6189 39.9636 22.5125 39.9636 19.915C39.9636 17.3167 37.8563 15.21 35.2588 15.21Z",
    fill: "#08533F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.258 15.2101V14.9961C34.0224 14.9961 32.8964 15.4552 32.0335 16.2061C31.9514 16.2771 31.9361 16.3986 31.9969 16.4884C32.6504 17.445 33.0323 18.5988 33.0323 19.842C33.0323 21.1228 32.6239 22.3051 31.9339 23.279C31.8712 23.3678 31.8847 23.489 31.9653 23.5615C32.8364 24.3491 33.9905 24.8331 35.258 24.8331C37.9735 24.8328 40.1768 22.6307 40.1768 19.9152C40.1768 17.1984 37.9735 14.9967 35.258 14.9961V15.4241C36.4981 15.4241 37.6196 15.9266 38.4329 16.7396C39.2463 17.553 39.7487 18.6744 39.7487 19.9152C39.7487 21.1553 39.2463 22.2765 38.4329 23.0898C37.6196 23.9026 36.4981 24.4047 35.258 24.405C34.1002 24.4047 33.0495 23.9641 32.2519 23.2439L32.1086 23.4029L32.2832 23.5265C33.0215 22.485 33.4603 21.2144 33.4603 19.842C33.4603 18.5105 33.0504 17.2716 32.3506 16.2473L32.1737 16.3676L32.3143 16.5293C33.1042 15.842 34.1295 15.4241 35.258 15.4241V15.2101Z",
    fill: "#CCF0E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8765 33.6349H11.2188C12.0121 27.5057 15.0748 25.8428 18.735 25.8428C20.3325 25.8428 21.8168 26.1604 23.048 27.0267C20.4739 28.0457 18.7627 30.2348 17.8765 33.6349Z",
    fill: "#08533F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13495_34396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 25,
    width: 13,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.6084H23.2662V33.874H11V25.6084Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13495_34396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8756 33.635V33.421H11.2179V33.635L11.4304 33.6627C11.6263 32.1461 11.9624 30.9133 12.4073 29.9192C13.0768 28.4281 13.9857 27.4733 15.0598 26.8798C16.1346 26.2873 17.3852 26.0569 18.7342 26.0569C19.5189 26.0569 20.2717 26.1351 20.9746 26.3171C21.6776 26.4994 22.3316 26.7848 22.9245 27.2021L23.0472 27.0268L22.9688 26.8279C21.6474 27.3503 20.542 28.1781 19.6601 29.306C18.7772 30.4342 18.1173 31.8595 17.6684 33.5812L17.8756 33.635L18.0826 33.6888C18.5201 32.0105 19.1588 30.6412 19.9971 29.5698C20.8359 28.4985 21.8728 27.7224 23.1262 27.2258C23.1991 27.1972 23.2504 27.1301 23.26 27.052C23.2692 26.9742 23.2345 26.897 23.1705 26.8518C22.5315 26.4026 21.8276 26.096 21.0819 25.9029C20.3356 25.7095 19.5472 25.6289 18.7342 25.6289C17.8031 25.6289 16.9039 25.7347 16.0638 25.9942C14.804 26.3823 13.6788 27.1234 12.8052 28.3518C11.931 29.58 11.3062 31.2857 11.0057 33.608C10.9977 33.6688 11.0162 33.73 11.0571 33.7762C11.098 33.8232 11.1561 33.849 11.2179 33.849H17.8756C17.9731 33.849 18.058 33.7835 18.0826 33.6888L17.8756 33.635Z",
    fill: "#CCF0E1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7363 15.21C19.9181 15.21 20.994 15.6485 21.8203 16.3674C21.1441 17.3585 20.7477 18.5547 20.7477 19.8419C20.7477 21.1687 21.1714 22.395 21.8855 23.4027C21.0512 24.1567 19.9488 24.6189 18.7363 24.6189C16.1389 24.6189 14.0312 22.5125 14.0312 19.915C14.0312 17.3167 16.1389 15.21 18.7363 15.21Z",
    fill: "#08533F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7355 15.2101V15.4241C19.8637 15.4241 20.8889 15.842 21.6789 16.5293L21.8194 16.3676L21.6426 16.2473C20.9428 17.2716 20.5329 18.5105 20.5329 19.842C20.5329 21.2147 20.9717 22.485 21.71 23.5265L21.8846 23.4029L21.7413 23.2439C20.9437 23.9641 19.8933 24.4047 18.7355 24.405C17.495 24.4047 16.3736 23.9026 15.5602 23.0898C14.7472 22.2765 14.2444 21.1553 14.2444 19.9152C14.2444 18.6744 14.7472 17.553 15.5602 16.7396C16.3736 15.9266 17.495 15.4241 18.7355 15.4241V14.9961C16.0197 14.9967 13.817 17.1984 13.8164 19.9152C13.817 22.6307 16.0197 24.8328 18.7355 24.8331C20.003 24.8331 21.1568 24.3491 22.0279 23.5615C22.1085 23.489 22.122 23.3678 22.0593 23.279C21.3696 22.3051 20.9609 21.1228 20.9609 19.842C20.9609 18.5988 21.3434 17.445 21.9963 16.4884C22.0571 16.3989 22.0418 16.2771 21.96 16.2061C21.0971 15.4552 19.9707 14.9961 18.7355 14.9961V15.2101Z",
    fill: "#CCF0E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9704 36.2187C35.0239 28.9026 31.3671 26.918 26.999 26.918C22.6294 26.918 18.9738 28.9026 18.0273 36.2187H35.9704Z",
    fill: "#08533F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13495_34396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 26,
    width: 20,
    height: 11
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7539 26.6318H36.2532V36.4356H17.7539V26.6318Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13495_34396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9698 36.2188L36.182 36.1911C35.9434 34.3458 35.5329 32.8298 34.9781 31.5915C34.1473 29.7339 32.9849 28.5008 31.6104 27.7444C30.2358 26.9867 28.6599 26.7041 26.9985 26.7041C25.8896 26.7041 24.8207 26.8296 23.8232 27.138C22.3266 27.5989 20.992 28.4781 19.9548 29.9366C18.9164 31.395 18.1726 33.4239 17.8143 36.1911C17.8063 36.2526 17.8248 36.3132 17.8657 36.36C17.9066 36.4064 17.9644 36.4328 18.0268 36.4328H35.9698C36.0319 36.4328 36.0898 36.4064 36.1307 36.36C36.1715 36.3132 36.19 36.2526 36.182 36.1911L35.9698 36.2188V36.0048H18.0268V36.2188L18.2387 36.2459C18.4736 34.4332 18.8752 32.9578 19.4084 31.7665C20.2101 29.9793 21.302 28.8317 22.5923 28.1189C23.8829 27.407 25.3835 27.1321 26.9985 27.1321C28.0741 27.1321 29.1002 27.2545 30.0467 27.5467C31.4662 27.987 32.7066 28.8025 33.6925 30.185C34.6777 31.5675 35.4059 33.5263 35.7577 36.2459L35.9698 36.2188Z",
    fill: "#CCF0E1"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6134 19.8425C32.6134 22.944 30.0989 25.4581 26.9984 25.4581C23.8966 25.4581 21.3828 22.944 21.3828 19.8425C21.3828 16.7414 23.8966 14.2275 26.9984 14.2275C30.0989 14.2275 32.6134 16.7414 32.6134 19.8425Z",
    fill: "#08533F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13495_34396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 12,
    height: 12
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 14H32.87V25.6869H21.1406V14Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13495_34396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6126 19.8427H32.3985C32.3985 21.335 31.794 22.6843 30.8164 23.6621C29.838 24.6397 28.4893 25.2442 26.9976 25.2442C25.505 25.2442 24.1563 24.6397 23.1781 23.6621C22.1999 22.6843 21.596 21.335 21.596 19.8427C21.596 18.3507 22.1999 17.0014 23.1781 16.0235C24.1563 15.0456 25.505 14.4423 26.9976 14.4417C28.4893 14.4417 29.838 15.0456 30.8164 16.0238C31.794 17.002 32.3985 18.3507 32.3985 19.8427H32.8266C32.8266 16.6231 30.2162 14.0143 26.9976 14.0137C23.7774 14.0143 21.168 16.6231 21.168 19.8427C21.168 23.0625 23.7774 25.6723 26.9976 25.6723C30.2162 25.6723 32.8266 23.0625 32.8266 19.8427H32.6126Z",
    fill: "#CCF0E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13495_34396",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13495_34396"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13495_34396",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScope3);
export default __webpack_public_path__ + "static/media/Scope3.f06a9eb885a74fcf81ad01742426e1f3.svg";
export { ForwardRef as ReactComponent };